// extracted by mini-css-extract-plugin
module.exports = {" _key":"dojo2-todo-mvc-kitchensink/todoList","todoList":"todoList-m__todoList__52e4152A2yF","cardList":"todoList-m__cardList__52e4157hQt6"};